import React, { FunctionComponent } from 'react';
import { Grid, Typography, InlineCode } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import StandardMarkdownNoMargin from '@modules/ui/markdown/components/StandardMarkdownNoMargin';
import OpenCloudAPIEndpoint from '../../../utils/interfaces/OpenCloudAPIEndpoint';
import { endpointsID } from '../constants/openCloudConstants';
import useEndpointsCategoryContainerStyle from './EndpointsCategoryContainer.style';

export interface EndpointsCategoryContainerProps {
  endpoint: OpenCloudAPIEndpoint;
  serverUrl?: string;
  className?: string;
}

const getTranslKeyByCategory = (category: string) => {
  if (category === 'Datastores') {
    return 'Label.DatastoresCategoryDescription';
  }

  if (category === 'Entries') {
    return 'Label.EntriesCategoryDescription';
  }

  if (category === 'Places') {
    return 'Label.PlacesCategoryDescription';
  }

  if (category === 'CrossServerMessaging') {
    return 'Label.CrossServerMessagingCategoryDescription';
  }

  // eslint-disable-next-line no-console
  if (process.env.environment !== 'production') console.warn('category not found: ', category);
  return '';
};

const EndpointsCategoryContainer: FunctionComponent<
  React.PropsWithChildren<EndpointsCategoryContainerProps>
> = ({ endpoint, serverUrl, className }) => {
  const { translate } = useTranslation();
  const {
    classes: { description: descriptionStyle, serverUrl: serverUrlStyle },
  } = useEndpointsCategoryContainerStyle();
  const description = translate(getTranslKeyByCategory(endpoint.category));

  return (
    <Grid direction='column' className={className} container>
      <Typography variant='h2' component='h2' id={`${endpointsID}-${endpoint.category}`}>
        {endpoint.category}
      </Typography>
      {serverUrl && (
        <Grid item className={serverUrlStyle}>
          <InlineCode>{serverUrl}</InlineCode>
        </Grid>
      )}
      {description && (
        <StandardMarkdownNoMargin className={descriptionStyle}>
          {description}
        </StandardMarkdownNoMargin>
      )}
    </Grid>
  );
};

export default EndpointsCategoryContainer;
